import React from 'react';
import { useSelector } from 'react-redux';
import TradeCard from '../portfolio/TradeCard';

// Individual trade item component
const TradeItem = ({ trade, priceChangeConfig, closeFromTrade }) => {
  // Get latest price data only for this specific instrument
  const quoteData = useSelector(
    (state) => state.trade.quotesData[trade?.script?.instrument_token]
  );
  
  // Merge the latest price data with the trade data
  const updatedTrade = {
    ...trade,
    script: { ...trade.script, ...quoteData }
  };
  
  return (
    <TradeCard
      trade={updatedTrade}
      priceChangeConfig={priceChangeConfig}
      closeFromTrade={closeFromTrade}
    />
  );
};

// Memoize the component to prevent re-renders when props don't change
// The component will only re-render if the trade ID changes or if the relevant quote data changes
export const MemoizedTradeItem = React.memo(TradeItem, 
  (prevProps, nextProps) => {
    // Only re-render if the trade ID changes
    if (prevProps.trade._id !== nextProps.trade._id) return false;
    
    // Re-render if the trade values have changed
    if (prevProps.trade.buy !== nextProps.trade.buy ||
        prevProps.trade.sell !== nextProps.trade.sell ||
        prevProps.trade.type !== nextProps.trade.type) {
      return false;
    }
    
    // If priceChangeConfig changes, we should re-render
    if (prevProps.priceChangeConfig !== nextProps.priceChangeConfig) {
      return false;
    }
    
    // Otherwise, don't re-render
    return true;
  }
);
